// extracted by mini-css-extract-plugin
export default {"subtitle":"ItemList_subtitle__R7Z2O","description":"ItemList_description__-0TqN","itemsHeader":"ItemList_itemsHeader__cCg1H"};